import React, {useContext} from "react";
import "./ExternalCollaborators.css";
import {externalCollaborators} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function ExternalCollaborators() {
  const {isDark} = useContext(StyleContext);
  
  if (!externalCollaborators.display) {
    return null;
  }
  
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="external-collaborators">
        <div>
          <h1 className="skills-heading">{externalCollaborators.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode collaborators-subtitle"
                : "subTitle collaborators-subtitle"
            }
          >
            {externalCollaborators.subtitle}
          </p>

          <div className="collaborators-container">
            {externalCollaborators.members.map((member, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode collaborator-card collaborator-card-dark"
                      : "collaborator-card collaborator-card-light"
                  }
                >
                  <div className={`collaborator-image-container collaborator-role-${member.roleType}`}>
                    <img
                      src={member.image}
                      alt={member.name}
                      className="collaborator-image"
                    />
                  </div>
                  <div className="collaborator-info">
                    <h3 className="collaborator-name">{member.name}</h3>
                    <p className={isDark ? "dark-mode collaborator-position" : "collaborator-position"}>
                      {member.position}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
